export const CONTAINER_TEST_ID = 'command-palette-integration.ui.container';
